import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from '@fortawesome/react-fontawesome';
import { IconBaseProps } from 'react-icons';
import {
  MdOutlineCircle,
  MdOutlineImage,
  MdOutlinePlayCircle,
  MdOutlineSquare,
} from 'react-icons/md';

import { Icon, IconProp } from 'react-icons-kit';
import { text } from 'react-icons-kit/iconic/text';
import { FaMousePointer } from 'react-icons/fa';
import { ReactComponent as TextHighlight } from '../assets/TextHighlightOutline.svg';

export const MediaIcon = (props: IconBaseProps) => (
  <MdOutlinePlayCircle {...props} />
);
export const ImageIcon = (props: IconBaseProps) => (
  <MdOutlineImage {...props} />
);
export const TextIcon = (props: IconProp) => <Icon icon={text} {...props} />;
export const HTMLIcon = (props: IconBaseProps) => (
  <svg
    color="inherit"
    width={props.size}
    height={props.size}
    viewBox="0 0 165 165"
  >
    <path
      d="M137 161H30C25.5817 161 22 157.418 22 153V12C22 7.58172 25.5817 4 30 4H109.907L145 37.2214V153C145 157.418 141.418 161 137 161Z"
      fill="transparent"
      stroke={'currentColor'}
      strokeWidth="8"
      strokeMiterlimit="16"
      strokeLinecap="round"
    />
    <path d="M143 39L108 4V39H143Z" fill="black" />
    <line
      x1="44"
      y1="68"
      x2="121"
      y2="68"
      stroke={'currentColor'}
      strokeWidth="8"
    />
    <line
      x1="44"
      y1="50"
      x2="121"
      y2="50"
      stroke={'currentColor'}
      strokeWidth="8"
    />
    <line
      x1="44"
      y1="86"
      x2="121"
      y2="86"
      stroke={'currentColor'}
      strokeWidth="8"
    />
    <line
      x1="44"
      y1="104"
      x2="121"
      y2="104"
      stroke={'currentColor'}
      strokeWidth="8"
    />
    <rect x="76" y="100" width="48" height="48" fill="white" />
    <ellipse cx="72.5" cy="105.5" rx="33.5" ry="32.5" fill="white" />
    <ellipse cx="73" cy="105.5" rx="27" ry="25.5" fill={'currentColor'} />
    <rect x="80" y="104" width="40" height="40" fill={'currentColor'} />
  </svg>
);
export const PointerIcon = (props: IconBaseProps) => (
  <FaMousePointer {...props} />
);
export const PencilIcon = (props: IconBaseProps) => (
  <svg
    color="inherit"
    width={props.size}
    height={props.size}
    viewBox={`0 0 20 20`}
  >
    <path
      fill={'currentColor'}
      d="M14.69,2.661c-1.894-1.379-3.242-1.349-3.754-1.266c-0.144,0.023-0.265,0.106-0.35,0.223l-4.62,6.374  l-2.263,3.123c-0.277,0.382-0.437,0.836-0.462,1.307l-0.296,5.624c-0.021,0.405,0.382,0.698,0.76,0.553l5.256-2.01  c0.443-0.17,0.828-0.465,1.106-0.849l1.844-2.545l5.036-6.949c0.089-0.123,0.125-0.273,0.1-0.423  C16.963,5.297,16.56,4.021,14.69,2.661z M8.977,15.465l-2.043,0.789c-0.08,0.031-0.169,0.006-0.221-0.062  c-0.263-0.335-0.576-0.667-1.075-1.03c-0.499-0.362-0.911-0.558-1.31-0.706c-0.08-0.03-0.131-0.106-0.126-0.192l0.122-2.186  l0.549-0.755c0,0,1.229-0.169,2.833,0.998c1.602,1.166,1.821,2.388,1.821,2.388L8.977,15.465z"
    />
  </svg>
);
export const CircleIcon = (props: IconBaseProps) => (
  <MdOutlineCircle {...props} />
);
export const RectIcon = (props: IconBaseProps) => (
  <MdOutlineSquare {...props} />
);
export const HighlightTextIcon = (props: IconBaseProps) => (
  <TextHighlight
    {...props}
    width={props.size || 24}
    height={props.size || 24}
  />
);
